import { getTimestamp, now } from "owa-datetime";

/**
 * How long each async item's notification card has been on screen, keyed by item id.
 *
 * Scoped to the card's mount: started when a card renders, dropped when that card leaves the DAB,
 * and consumed by the engagement it leads to. Measured separately from `getTimeInStatusMs` because
 * the two answer different questions -- the status clock runs from the moment the result existed,
 * this one from the moment the user could actually see it, and a result can be finished long before
 * a card is free to show it (the DAB renders only the top few cards of the stack, and a newly
 * submitted Working card holds the stack to itself for five seconds).
 */
const notificationVisibleSince: Map<string, number> = new Map<string, number>();

export function markNotificationVisible(id: string): void {
    notificationVisibleSince.set(id, getTimestamp(now()));
}

export function clearNotificationVisible(id: string): void {
    notificationVisibleSince.delete(id);
}

export function consumeNotificationVisibleMs(id: string): number | undefined {
    const visibleSince = notificationVisibleSince.get(id);
    if (visibleSince === undefined) {
        return undefined;
    }
    
    notificationVisibleSince.delete(id);
    return getTimestamp(now()) - visibleSince;
}
